import util from 'src/util/util';

/**
 * Created by huzhongchun on 2018/4/26.
 */

//project_label
export const PROJECT_LABEL = 'TRAINING';

//route base path
export const PRODUCT_ROUTE_BASE_PATH = '/lemon/page/entrance';
export const DEVELOPMENT_ROUTE_BASE_PATH = '';

//api host
export const API_ONLINE_HOST = window.location.protocol+'//api.thefair.net.cn';
export const APP_ID = 'ta9xja8vjq6nprzj';

//get token
export const GET_TOKEN_URL = '/lemon/page/get_token';
export const GET_TOKEN_REQUEST_BASEURL = window.location.origin;
export const GET_TOKEN_REQUEST_TYPE = 'lemon';

function getRouteBaseUrl () {
	if(process.env.NODE_ENV === 'development'){
		return DEVELOPMENT_ROUTE_BASE_PATH;
	}else{
		return PRODUCT_ROUTE_BASE_PATH;
	}
}

export const tabBar = [
	{
		path: getRouteBaseUrl()+'/',
		root: true,
		text: '今日阅读',
		icon:'',
		activeIcon:''
	},
	{
		path: getRouteBaseUrl()+'/user_center',
		text: '我的',
		icon:'',
		activeIcon:''
	},
];

export let defaultShareInfo = {
	wechat_session: {
		title: '元气读书听书训练营，让你收入加个零',
		text: '职场路上，永远先人一步。',
		image: {
			url: 'https://resource2.thefair.net.cn/_assets/react/training/static/image/share_img.png'
		},
		link: 'http://h5.molandapp.com/wechat/helper/redirect?url='+encodeURIComponent(window.location.origin + '/lemon/page/entrance/training'),
	},
	wechat_timeline: {
		title: '元气读书听书训练营，让你收入加个零',
		text: '职场路上，永远先人一步。',
		image: {
			url: 'https://resource2.thefair.net.cn/_assets/react/training/static/image/share_img.png'
		},
		link: 'http://h5.molandapp.com/wechat/helper/redirect?url='+encodeURIComponent(window.location.origin +'/lemon/page/entrance/training'),
	}
};

export default {
	PRODUCT_ROUTE_BASE_PATH,
	DEVELOPMENT_ROUTE_BASE_PATH,
	API_ONLINE_HOST,
	GET_TOKEN_URL,
	tabBar
};



// WEBPACK FOOTER //
// ./src/config/configTraining.js